<div
  class="wrapper flex column"
  [class.close]="!open()"
>
  <div class="logo-box flex hcenter vcenter">
    @if (open()) {
      <img
        class="logo"
        src="assets/shared/global-images/payee-logos/v1/white-payee-with-badge.svg"
        width="100px"
        alt="Payee"
        routerLink="dashboard"
      />
    }
    @if (!open()) {
      <img
        class="logo"
        src="assets/shared/global-images/payee-logos/v1/payee-webclip-white.svg"
        width="56.83px"
        alt="Payee"
        routerLink="dashboard"
      />
    }
  </div>

  <div class="sidebar-nav flex column">
    @if (showHiddenPages) {
      <div
        class="menu-button flex vcenter"
        routerLinkActive="active"
        routerLink="bulk-upload"
        matTooltipPosition="right"
        [matTooltip]="open() ? '' : 'TÖMEGES FELTÖLTÉS'"
      >
        <payee-icon name="arrow-right-grey"></payee-icon>
        <span [class.close]="!open()">TÖMEGES FELTÖLTÉS</span>
      </div>
    }

    @if (showHiddenPages) {
      <div
        class="menu-button flex vcenter"
        routerLinkActive="active"
        routerLink="workflow-editor"
        matTooltipPosition="right"
        matTooltipClass="sidebar-tooltip"
        [matTooltip]="open() ? '' : 'WORKFLOW'"
      >
        <payee-icon name="arrow-right-grey"></payee-icon>
        <span [class.close]="!open()">WORKFLOW</span>
      </div>
    }
    @if (showHiddenPages) {
      <div
        class="menu-button flex vcenter"
        routerLinkActive="active"
        routerLink="product-prices"
        matTooltipPosition="right"
        matTooltipClass="sidebar-tooltip"
        [matTooltip]="open() ? '' : 'SZOLGÁLTATÁSOK'"
      >
        <payee-icon name="arrow-right-grey"></payee-icon>
        <span [class.close]="!open()">SZOLGÁLTATÁSOK</span>
      </div>
    }
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="metrics"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'KIMUTATÁSOK'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">KIMUTATÁSOK</span>
    </div>
    @if (showHiddenPages) {
      <div
        class="menu-button flex vcenter"
        routerLinkActive="active"
        routerLink="product-discounts"
        matTooltipPosition="right"
        matTooltipClass="sidebar-tooltip"
        [matTooltip]="open() ? '' : 'KEDVEZMÉNYEK'"
      >
        <payee-icon name="arrow-right-grey"></payee-icon>
        <span [class.close]="!open()">KEDVEZMÉNYEK</span>
      </div>
    }
    @if (showHiddenPages) {
      <div
        class="menu-button flex vcenter"
        routerLinkActive="active"
        routerLink="enums"
        matTooltipPosition="right"
        matTooltipClass="sidebar-tooltip"
        [matTooltip]="open() ? '' : 'ENUMS'"
      >
        <payee-icon name="arrow-right-grey"></payee-icon>
        <span [class.close]="!open()">ENUMS</span>
      </div>
    }
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="info-notifications"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'ÉRTESÍTÉSEK'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">ÉRTESÍTÉSEK</span>
    </div>
    @if (showHiddenPages) {
      <div
        class="menu-button flex vcenter"
        routerLinkActive="active"
        routerLink="partners"
        matTooltipPosition="right"
        matTooltipClass="sidebar-tooltip"
        [matTooltip]="open() ? '' : 'PARTNEREK'"
      >
        <payee-icon name="arrow-right-grey"></payee-icon>
        <span [class.close]="!open()">PARTNEREK</span>
      </div>
    }
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="szamlazzhu"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'SZÁMLÁZZ.HU'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">SZÁMLÁZZ.HU</span>
    </div>
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="cases-list"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'ÖSSZES ÜGY'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">ÖSSZES ÜGY</span>
    </div>
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="payee-case-mokk"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'MOKK IRATOK'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">MOKK IRATOK</span>
    </div>
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="clients"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'HITELEZŐK'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">HITELEZŐK</span>
    </div>
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="users"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'FELHASZNÁLÓK'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">FELHASZNÁLÓK</span>
    </div>
    <div
      class="menu-button flex vcenter"
      routerLinkActive="active"
      routerLink="law-firms"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'ÜGYVÉDI IRODÁK'"
    >
      <payee-icon name="arrow-right-grey"></payee-icon>
      <span [class.close]="!open()">ÜGYVÉDI IRODÁK</span>
    </div>
    <div class="logout-divider"></div>
    <div
      class="menu-button flex vcenter"
      role="button"
      tabindex="0"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [matTooltip]="open() ? '' : 'KIJELENTKEZÉS'"
      (click)="logout()"
      (keydown.enter)="logout()"
      (keydown.space)="logout(); $event.preventDefault()"
    >
      <payee-icon name="logout-red"></payee-icon>
      <span
        color="alert-red"
        [class.close]="!open()"
      >
        Kijelentkezés
      </span>
    </div>
  </div>

  <div class="sidebar-footer">
    <!--<div [class.close]="!open()" class="payee-email">hello@payee.tech</div>-->
    <div
      class="version"
      [class.close]="!open()"
    >
      Verziószám:
      <strong #appVersion>v{{ versionNumber }}</strong>
    </div>
    <button
      mat-button
      class="toggle-button"
      [class.close]="!open()"
      (click)="toggleOpen()"
    >
      @if (open()) {
        <img
          src="assets/shared/global-images/icons/arrow-double-left-grey.svg"
          alt=""
        />
      }
      @if (!open()) {
        <img
          src="assets/shared/global-images/icons/arrow-double-right-grey.svg"
          alt=""
        />
      }
    </button>
  </div>
</div>
